// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Facebook: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
            <path
                d="M21.875,0 L2.625,0 C1.92880666,0 1.26112783,0.276561737 0.768844366,0.768844366 C0.276561737,1.261127 0,1.92880583 0,2.625 L0,21.875 C0,22.5711925 0.276561737,23.238873 0.768844366,23.7311556 C1.26112783,24.2234383 1.92880666,24.5 2.625,24.5 L10.1308594,24.5 L10.1308594,16.170547 L6.68554688,16.170547 L6.68554688,12.25 L10.1308594,12.25 L10.1308594,9.26187503 C10.1308594,5.86304641 12.1542969,3.98562527 15.2534366,3.98562527 C16.7376561,3.98562527 18.289686,4.25031257 18.289686,4.25031257 L18.289686,7.58625007 L16.5796084,7.58625007 C14.8946867,7.58625007 14.3691406,8.6318748 14.3691406,9.70429671 L14.3691406,12.25 L18.1305468,12.25 L17.5289843,16.170547 L14.3691406,16.170547 L14.3691406,24.5 L21.875,24.5 C22.5711925,24.5 23.238873,24.2234383 23.7311556,23.7311556 C24.2234383,23.238873 24.5,22.5711925 24.5,21.875 L24.5,2.625 C24.5,1.92880583 24.2234383,1.261127 23.7311556,0.768844366 C23.238873,0.276561737 22.5711925,0 21.875,0 Z"
                transform="translate(0 .25)"
            />
        </svg>
    );
};

export default React.memo(Facebook);
